import * as React from 'react'
import classNames from 'classnames'
import * as style from './style.module.scss'

export default function SnappySlider({ className, ...props }) {
  return (
    <div className={classNames(style.snappySlider, className)} {...props} />
  )
}
